// Iconos para el stepper de SOAT
export const SOAT_STEPPER_ICONS = {
  oneActive: require('@/assets/formpp/number-one-checked.svg'),
  oneChecked: require('@/assets/formpp/number-one-checked.svg'),
  twoActive: require('@/assets/formpp/number-two-checked.svg'),
  twoDisabled: require('@/assets/formpp/number-two-disabled.svg')
}



// WEBPACK FOOTER //
// ./src/constants/soatAssets.js